'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var url = _interopDefault(require('url'));
var isbot = _interopDefault(require('isbot'));

// RegExp strings to extend `isbot` user-agent string checking.
//
// See: https://www.npmjs.com/package/isbot#extending
var userAgents = ['PTST/SpeedCurve', 'Cypress', 'www.monitis.com'];

// @ts-ignore "extend" is documented in the `isbot` README.
//   See: https://www.npmjs.com/package/isbot#extending
isbot.extend(userAgents);
/**
 * Check if a given URL has a special __BOT__ query param
 */
function isBotUrl(requestUrl) {
    const parsedUrl = url.parse(requestUrl, true);
    return parsedUrl.query['__BOT__'] !== undefined;
}
/**
 * Check if a given user agent matches any known bot user agents.
 *
 * This includes all the user agents from the `isbot` NPM package, as well as some
 *   additional bot user agent strings that we know access our site(s).
 */
function isBotUserAgent(userAgent) {
    if (userAgent === '') {
        return true;
    }
    return isbot(userAgent);
}
/**
 * Check if an HTTP request appears to have originated from a bot.
 *
 * This checks for an explicit X-Deal-Is-Bot header, as well as checking the request
 *   URL and user agent.
 */
function isBotRequest(req) {
    const botHeader = req.headers['x-deal-is-bot'];
    const userAgentHeader = req.headers['user-agent'];
    if (botHeader) {
        return true;
    }
    else if (req.url && isBotUrl(req.url)) {
        return true;
    }
    else if (userAgentHeader === undefined ||
        Array.isArray(userAgentHeader) ||
        isBotUserAgent(userAgentHeader)) {
        return true;
    }
    return false;
}

exports.isBotRequest = isBotRequest;
exports.isBotUrl = isBotUrl;
exports.isBotUserAgent = isBotUserAgent;
//# sourceMappingURL=index.js.map
